import { render, staticRenderFns } from "./20201203.vue?vue&type=template&id=cccc5d36&lang=pug&"
var script = {}
import style0 from "./20201203.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports